module.exports = __webpack_public_path__ + "static/anana-vestige-logo-wallpaper-background-white-e52bb90b04aeef4bfeda46f2cd36aa53.png";